

const LoginFooter = () => {
    return (
        <div className="w-full mt-6 space-y-4 text-center">
            <div className="h-[1px] w-full bg-gradient-to-r from-transparent via-white/5 to-transparent" />

            <p className="text-[10px] text-primary-200/40 font-sans tracking-wide px-2">
                New here? Your account is <span className="text-primary-300/60 font-medium">created automatically</span> when you sign in.
            </p>

            <div className="pt-4 text-center flex flex-col items-center gap-3">
                <div className="text-[9px] text-primary-100/10 uppercase tracking-[0.4em] font-sans font-semibold hover:text-primary-100/30 transition-colors cursor-default">
                    BhriguGPT • Cosmic Wisdom
                </div>
            </div>
        </div>
    );
};

export default LoginFooter;
